module.exports = __webpack_public_path__ + "img/chr_ts_90_24_2.2235e3da.png";